import { useState, useEffect } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import { format, addMonths } from "date-fns";
import { th } from "date-fns/locale";
import "./styles/MaintenanceTracker.css";

const MaintenanceTracker = ({ someProp = "default value" }) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const currentDate = new Date();
    const months = Array.from({ length: 7 }, (_, index) => {
      const monthDate = addMonths(currentDate, -index);
      return {
        month: format(monthDate, "LLLL", { locale: th }),
        completed: Math.floor(Math.random() * 50) + 10,
        inProgress: Math.floor(Math.random() * 30) + 5,
        newJobs: Math.floor(Math.random() * 20),
      };
    });

    setData(months.reverse());
  }, []);

  return (
    <div className="chart-container">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          margin={{ top: 15, right: 0, left: 0, bottom: 0 }}
        >
          <CartesianGrid stroke="none" strokeDasharray="3 3" />
          <XAxis
            dataKey="month"
            axisLine={{ stroke: "none" }}
            interval={0}
            tick={{ fontSize: 12, fill: "#FFFFFF" }}
            angle={45}
            textAnchor="start"
            height={70}
            orientation="bottom"
            tickLine={true}
          />
          <YAxis
            stroke="#FFFFFF"
            tick={{ fill: "#FFFFFF", fontSize: 10 }}
            orientation="left"
            tickLine={true}
          />
          <Tooltip
            labelStyle={{ color: "#FFFFFF" }}
            contentStyle={{
              borderRadius: "10px",
              backgroundColor: "#003CD3",
              boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
            }}
          />
          <Bar
            dataKey="completed"
            stackId="a"
            fill="#40D299"
            name="เสร็จสิ้น"
            barSize={30}
            radius={8}
          />
          <Bar
            dataKey="inProgress"
            stackId="a"
            fill="#FFC443"
            name="กำลังดำเนินการ"
            radius={8}
          />
          <Bar
            dataKey="newJobs"
            stackId="a"
            fill="#0C62F5"
            name="รายงานปัญหาใหม่"
            barSize={30}
            radius={8}
          />
        </BarChart>
      </ResponsiveContainer>
      <div className="legend">
        <Legend
          iconType="rect"
          tick={{ fill: "#FFFFFF", fontSize: 10 }}
          payload={[
            {
              value: "เสร็จสิ้น",
              type: "rect",
              color: "#40D299",
              className: "legend-item",
            },
            {
              value: "กำลังดำเนินการ",
              type: "rect",
              color: "#FFC443",
              className: "legend-item",
            },
            {
              value: "รายงานปัญหาใหม่",
              type: "rect",
              color: "#0C62F5",
              className: "legend-item",
            },
          ]}
        />
      </div>
    </div>
  );
};

export default MaintenanceTracker;